import { Calendar, Users, Trophy, Award } from 'lucide-react';

const timelineItems = [
  {
    icon: Calendar,
    title: 'Регистрация и отборочный этап',
    date: '21 октября – 2 ноября 2026',
    description: 'Подай заявку на участие, пройди онлайн-тестирование и выполни первое задание по выбранной компетенции.',
    color: 'from-blue-500 to-cyan-500',
  },
  {
    icon: Users,
    title: 'Командообразование',
    date: '10–20 ноября 2026',
    description: 'Познакомься с будущими коллегами, сформируй команду и получи менторскую поддержку для разработки проекта.',
    color: 'from-purple-500 to-pink-500',
  },
  {
    icon: Trophy,
    title: 'Финальный хакатон',
    date: '21–30 ноября 2026',
    description: 'Работай над проектом в команде, участвуй в мастер-классах и готовься к защите перед экспертами.',
    color: 'from-amber-500 to-orange-500',
  },
  {
    icon: Award,
    title: 'Награждение и итоги',
    date: '5–9 декабря 2026',
    description: 'Представь свой проект жюри, получи обратную связь от профессионалов и возможность выиграть гранты и стажировки.',
    color: 'from-emerald-500 to-teal-500',
  },
];

export default function TimelineSection() {
  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
            Этапы чемпионата
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            От регистрации до финала — каждый шаг приближает тебя к профессиональному успеху.
          </p>
        </div>

        <div className="relative">
          {/* Вертикальная линия таймлайна */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-gradient-to-b from-blue-500 via-purple-500 to-emerald-500 hidden md:block"></div>

          <div className="space-y-12">
            {timelineItems.map((item, index) => (
              <div
                key={item.title}
                className={`relative flex flex-col md:flex-row items-center ${
                  index % 2 === 0 ? 'md:flex-row-reverse' : ''
                }`}
              >
                {/* Точка на линии */}
                <div className="absolute left-1/2 transform -translate-x-1/2 w-6 h-6 rounded-full bg-white border-4 border-primary-500 z-10 hidden md:block"></div>

                {/* Контент */}
                <div
                  className={`w-full md:w-5/12 ${
                    index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'
                  }`}
                >
                  <div className="bg-white rounded-2xl shadow-lg p-6 hover:shadow-xl transition-shadow">
                    <div className="flex items-center space-x-4 mb-4">
                      <div className={`p-3 rounded-lg bg-gradient-to-r ${item.color}`}>
                        <item.icon className="h-6 w-6 text-white" />
                      </div>
                      <div>
                        <h3 className="text-xl font-bold text-gray-900">{item.title}</h3>
                        <p className="text-sm text-gray-500 font-medium">{item.date}</p>
                      </div>
                    </div>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                </div>

                {/* Пустое пространство для выравнивания */}
                <div className="hidden md:block md:w-2/12"></div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-12">
          <p className="text-gray-700 max-w-2xl mx-auto">
            Участие в каждом этапе бесплатное. Отборочный этап проходит онлайн, финал — в очно-заочном формате.
          </p>
        </div>
      </div>
    </section>
  );
}